var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 184 184",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1E91FF",
    d: "M157 156.4c35.4-35.6 35.4-93.6.1-129.3C139.7 9.6 116.6 0 91.8 0 67 0 43.8 9.6 26.5 27.1-.700012 54.7-7.70001 96.6 8.99999 131.5 11 135.6 15.1 138.2 19.7 138.2c3.2 0 6.2-1.3 8.4-3.5 3.5-3.6 4.5-9 2.3-13.4C17.8 94.9 23.3 63.4 44.2 43 57 30.5 73.9 23.6 91.8 23.6c17.1 0 33.4 6.4 46 17.9 13.8 12.7 21.6 29.9 22 48.6.4 18.7-6.6 36.2-19.7 49.5-12.9 13-30 20.1-48.3 20.1-9.8 0-19.6-2.2-28.5-6.2-1.5-.7-3.1-1-4.8-1-3.1 0-6.2 1.3-8.5 3.5-2.8 2.8-4 6.6-3.2 10.5.7 3.9 3.2 7.1 6.9 8.8 11.8 5.4 25 8.2 38.1 8.2 24.7 0 47.8-9.6 65.2-27.1zM65 76.1l26.7-21.2 26.7 21.2v44.1H65V76.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSmall);
export default __webpack_public_path__ + "static/media/logo-small.1e13e7f3f0b5f9047f4ce81e0a3d55f5.svg";
export { ForwardRef as ReactComponent };